import { render } from "./milestone-sidebar.vue?vue&type=template&id=6c19cc75&scoped=true&ts=true"
import script from "./milestone-sidebar.vue?vue&type=script&lang=ts"
export * from "./milestone-sidebar.vue?vue&type=script&lang=ts"

import "./milestone-sidebar.vue?vue&type=style&index=0&id=6c19cc75&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c19cc75"]])

export default __exports__